module.exports = __webpack_public_path__ + "img/fi-powerskills.94df0373.png";